import React, { useState, useEffect, useRef } from 'react';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { useTranslation } from 'react-i18next';


import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import EventBus from "../../common/EventBus";
import { Toast } from 'primereact/toast';
import AuthService from '../../security/AuthService';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import AccountService from '../../service/AccountService';
import utils from '../../constants/utils';
import Constants from '../../constants/Constants';
import CompanyService from '../../service/CompanyService';
import { useNavigate } from 'react-router-dom';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import { Exhibition } from '../exhibition/Exhibition';
import ExhibitionService from '../../service/ExhibitionService';
import { InputTextarea } from 'primereact/inputtextarea';

export const ExhibitionManagement = (props) => {

    const navigate = useNavigate();

    const { t } = useTranslation();
    const toast = useRef(null);
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);
    const [filters, setFilters] = useState(null);

    const [status, setStatus] = useState(Constants.exhibitionStatus.IN_REVIEW);

    const [accountList, setAccountList] = useState([]);

    const [selectedExhibiton, setSelectedExhibiton] = useState([]);
    const [loadingApprovalList, setLoadingApprovalList] = useState(true);

    const [displayAccountDialog, setDisplayAccountDialog] = useState(false);

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [webSite, setWebSite] = useState('');
    const [userName, setUserName] = useState('');

    const [userTypes, setUserTypes] = useState(Constants.userTypes);
    const [userType, setUserType] = useState('');


    const [companyType, setCompanyType] = useState();
    const [companyName, setCompanyName] = useState('');
    const [companyId, setCompanyId] = useState(null);

    const [title, setTitle] = useState('');
    const [companyWebSite, setCompanyWebSite] = useState('');

    const [address, setAddress] = useState('');

    const [companyTypes, setCompanyTypes] = useState([]);
    const [selectedCompanyType, setSelectedCompanyType] = useState();

    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');

    const [hasBluetick, setHasBluetick] = useState(false);

    const [newstatus, setNewstatus] = useState(true);
    const [roles, setRoles] = useState(null);
    const [selectedRoles, setSelectedRoles] = useState(null);
    const [rejectDialogVisible, setRejectDialogVisible] = useState(false);

    const [rejectMessage, setRejectMessage] = useState('');
    const [exhibitionOverviewData, setExhibitionOverviewData] = useState([]);


    useEffect(() => {
        loadAll();

    }, []);

    const loadAll = () => {
        onLoadData(status);
        loadCompanyTypes();
        loadRoles();
        onOverViewData();
    }

    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }

    const exhibitionOverview = [
        {
            "shrt_code": "IN_REVIEW",
            "name": "filter_appointment_pending",
            "status": 2
        },
        {
            "shrt_code": "SCHEDULED",
            "name": "filter_appointment_scheduled",
            "status": 10
        },
        {
            "shrt_code": "PUBLISHED",
            "name": "filter_appointment_published",
            "status": 11
        },

        {
            "shrt_code": "DRAFT",
            "name": "filter_appointment_draft",
            "status": 1
        },
        {
            "shrt_code": "EXPIRED",
            "name": "filter_appointment_expired",
            "status": 4
        },
        {
            "shrt_code": "REJECTED",
            "name": "filter_appointment_not_approved",
            "status": 5
        }


    ]







    const onLoadData = (param) => {
        setDisplayLoadingDialog(true);
        setAccountList([]);
        ExhibitionService.inquireExhibitByStatus(param).then(
            (response) => {
                console.log("inquireUserbyValidation", response)
                console.log("inquireUserbyValidation", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireUserbyValidation", response?.data?.data?.dataList)
                    setAccountList(response?.data?.data?.dataList);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireapprovallistbystatus logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }
    const loadCompanyTypes = () => {
        console.log("companyTypes", companyTypes, companyTypes?.length)
        if (companyTypes?.length === 0) {
            showLoading();
            CompanyService.inquiereCompanyTypes().then(
                (response) => {
                    console.log("inquiereCompanyTypes", response?.data?.data?.dataList)
                    if (response?.data?.data?.dataList?.length > 0) {
                        let _companyTypes = response?.data?.data?.dataList;
                        setCompanyTypes(_companyTypes);
                    }
                    hideLoading();
                },
                (error) => {
                    hideLoading();
                    console.log("errror", error);
                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        console.log("do loggout");
                        navigate('/')
                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );

        }
    }
    const loadRoles = () => {
        console.log("loadRoles", roles)
        if (!roles || roles?.length === 0) {
            showLoading();
            AccountService.inquireRoles().then(
                (response) => {
                    console.log("inquireRoles", response?.data?.data?.dataList)
                    if (response?.data?.data?.dataList?.length > 0) {
                        let _roles = response?.data?.data?.dataList;
                        setRoles(_roles);
                    }
                    hideLoading();
                },
                (error) => {
                    hideLoading();
                    console.log("errror", error);
                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        console.log("do loggout");
                        navigate('/')
                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );

        }
    }
    const onOverViewData = () => {

        setExhibitionOverviewData([]);
        ExhibitionService.inquireExhibitOverviewReport().then(
            (response) => {
                console.log("inquireExhibitOverviewReport", response)
                console.log("inquireExhibitOverviewReport", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireExhibitOverviewReport", response?.data?.data?.dataList)
                    let _dataList = response?.data?.data?.dataList;

                    let _overviewDataList = [];
                    let _totalCount = 0;
                    _dataList.forEach(_data => {
                        _totalCount = Number(_data.value) + _totalCount;
                    });
                    exhibitionOverview.forEach(_overview => {
                        _dataList.forEach(_data => {

                            if (_data.key == _overview.status) {
                                let _overviewData = {
                                    "shrt_code": _overview.shrt_code,
                                    "name": _overview.name,
                                    "status": _overview.status,
                                    "count": _data.value,
                                    "percentage": ((Number(_data.value) / _totalCount) * 100).toFixed(2)
                                }
                                console.log("_overviewData", _overviewData, " -- ", _data.value, " -- ", _totalCount, " -- ", ((Number(_data.value) / _totalCount) * 100).toFixed(2));
                                _overviewDataList.push(_overviewData);
                            }
                        })


                    });


                    setExhibitionOverviewData(_overviewDataList);
                }

            },
            (error) => {


                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireapprovallistbystatus logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }

    const exportToExcel = () => {
        console.log("exportexcel", accountList);

        if (accountList != null) {
            import('xlsx').then(xlsx => {
                const worksheet = xlsx.utils.json_to_sheet(accountList);
                const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                saveAsExcelFile(excelBuffer, 'Approval List');
            });
        }
    }


    const saveAsExcelFile = (buffer, fileName) => {

        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });

    }

    const onUpdateApprovalListStatus = (_selectedExhibiton, newStatus) => {



        if (_selectedExhibiton) {


            const apiParams = { id: _selectedExhibiton.id, status: newStatus, apprMessage: rejectMessage };
            if (newStatus == Constants.exhibitionStatus.REJECTED) {
                setRejectDialogVisible(false);
                setRejectMessage("");
            }
            ExhibitionService.changeStatus(apiParams).then(
                (response) => {
                    console.log("changeStatus", response)
                    onLoadData(status);
                },
                (error) => {
                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            console.log("Select changeStatus");
        }

    }


    const leftToolbarTemplate = () => {
        return (
            <h5>{t('global_text_exhibitionsettings')}</h5>
        )
    }
    const onStatusChange = (param) => {

        setStatus(param);
        onLoadData(param);
    }

    const rightToolbarTemplate = () => {


        return (
            <React.Fragment>
                <span className="p-buttonset pr-3">
                    <Button label={t("filter_appointment_pending")} icon="fa fa-clock" disabled={status === Constants.exhibitionStatus.IN_REVIEW} onClick={() => onStatusChange(Constants.exhibitionStatus.IN_REVIEW)} />
                    <Button label={t("filter_appointment_approved")} icon="fa fa-check" disabled={status === Constants.exhibitionStatus.APPROVED} onClick={() => onStatusChange(Constants.exhibitionStatus.APPROVED)} />
                    <Button label={t("filter_appointment_not_approved")} icon="fa fa-times" disabled={status === Constants.exhibitionStatus.REJECTED} onClick={() => onStatusChange(Constants.exhibitionStatus.REJECTED)} />
                    <Button label={t("filter_appointment_expired")} icon="fa fa-calendar-xmark" disabled={status === Constants.exhibitionStatus.EXPIRED} onClick={() => onStatusChange(Constants.exhibitionStatus.EXPIRED)} />

                </span>
                <Button type="button" icon="fa fa-file-excel" onClick={exportToExcel} className="mr-2" title={t('export_to_excel')} />
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="fa fa-check" className="p-button-rounded p-button-success p-button-outlined mr-2 mb-2" onClick={() => onUpdateApprovalListStatus(rowData, Constants.exhibitionStatus.APPROVED)} />
                <Button icon="fa fa-times" className="p-button-rounded p-button-danger p-button-outlined mr-2 mb-2" onClick={() => { setSelectedExhibiton(rowData); setRejectDialogVisible(true) }} />
                <Button icon="fa fa-eye" className="p-button-rounded p-button-secondary p-button-outlined mr-2 mb-2" onClick={() => onAccountSelect(rowData)} />

            </React.Fragment>
        );
    }


    const statusBodyTemplate = (data) => {
        return (
            <>
                <div>
                    <span style={
                        { color: data?.status === Constants.exhibitionStatus.APPROVED ? '#0BD18A' : '#FC6161' }}>{t('global_text_exhbitionstatus_' + data?.status)}</span>
                </div>


            </>
        )
    };


    const companyTypeTemplate = (data) => {
        return (
            <>
                <div>
                    {t('global_text_' + data?.userType)}
                </div>


            </>
        )
    };


    const dateTemplate = (rowData) => {
        if (rowData.cdate) {
            return utils.formatDateTime(new Date(rowData.cdate));
        }
        return null;
    }
    const udateTemplate = (rowData) => {
        if (rowData.udate) {
            return utils.formatDateTime(new Date(rowData.udate));
        }
        return null;
    }

    const onHideDialog = () => {

        setDisplayAccountDialog(false);
    }
    const onAccountSelect = (param) => {
        defaultDialogData();
        setSelectedExhibiton(param);

        setFirstName(param.firstName);
        setLastName(param.lastName);
        setUserName(param.userName);
        setEmail(param.email);
        setWebSite(param.webSite);
        setCompanyId(param.companyId);
        setCompanyType(param.companyType);
        setCompanyName(param.companyName);
        setTitle(param.title);
        setCompanyWebSite(param.companyWebSite);
        setAddress(param.address);
        // setSelectedCompanyType(param.selectedCompanyType);

        setSelectedRoles(param.roles);
        setNewstatus(false);
        setDisplayAccountDialog(true);
        setHasBluetick(param?.hasBluetick === 1 ? true : false);


        userTypes.map((_userType, index) => {
            if (_userType.type === param.userType) {
                setUserType(_userType);
            }
        });
        companyTypes.map((_companyType, index) => {
            console.log("_companyType", _companyType, param.companyType)

            if (_companyType.code === param.companyType) {
                setSelectedCompanyType(_companyType);
            }
        });

    }
    const defaultDialogData = () => {


        setFirstName('');
        setLastName('');
        setUserName('');
        setEmail('');
        setWebSite('');

        setNewstatus(true);


    }
    const actionFooter = () => {
        if (newstatus) {
            return (
                <div className="grid">

                </div>
            )
        } else {
            return (
                <div className="grid">
                    <div className="col-12 md:col-4">
                        <Button label={t('global_btn_update')} icon="fa fa-save" className="p-button" onClick={onUpdateAccount}></Button>
                    </div>
                    <div className="col-12 md:col-4">
                        <Button label={selectedExhibiton?.active === 'Y' ? t('global_btn_passive') : t('global_btn_active')} icon="fa fa-times-circle" className="p-button" onClick={() => onUpdateAccount(selectedExhibiton?.active === 'Y' ? 'N' : 'Y')}></Button>
                    </div>
                    <div className="col-12 md:col-4">
                        <Button label={t('global_btn_cancel')} icon="fa fa-ban" className="p-button" onClick={() => onHideDialog('displayHospitalDialog')}></Button>
                    </div>
                </div>
            )
        }
    }

    const onUpdateAccount = () => {

        console.log(userType.type, firstName, lastName, email)


        console.log("onUpdateAccount");
        if (firstName?.length > 0 && lastName?.length > 0 && email?.length > 0) {
            setDisplayLoadingDialog(true);

            const apiParams = {
                id: selectedExhibiton.id, userType: userType.type, firstName: firstName, lastName: lastName, email: email,
                roles: selectedRoles, hasBluetick: hasBluetick ? 1 : 0
            };
            if (userType.type === 'company') {
                apiParams.title = title;
                apiParams.companyName = companyName;
                if (companyId) {
                    apiParams.companyId = companyId;
                }
                //
                apiParams.companyType = selectedCompanyType.id;

                apiParams.address = address;
                //  apiParams.companyPhoneNumber = companyPhoneNumber;
                apiParams.companyWebSite = companyWebSite;

            }
            if (selectedRoles) {
                //   apiParams.roles={roles:selectedRoles};

            }
            let _userList = [];
            _userList.push(apiParams);
            let _updateRequest = { users: _userList }

            AccountService.updateUsers(_updateRequest).then(

                (response) => {

                    console.log("updateUsers", response);

                    if (response?.data?.error) {
                        setDisplayLoadingDialog(false);

                        let _detail = response.data.error?.innerExceptionMessage;
                        if (t(_detail)) {
                            _detail = t(_detail);
                        }


                        toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                    } else {
                        console.log("onRegister", response);
                        loadAll();

                        setDisplayLoadingDialog(false);
                        setDisplayAccountDialog(false);

                        toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: t('global_success'), life: 3000 });
                    }
                },
                (error) => {
                    setDisplayLoadingDialog(false);

                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_detail"), life: 5000 });

        }

    }


    const rejectDialogFooter = (
        <div>
            <Button label={t('global_btn_cancel')} icon="pi pi-times" onClick={() => setRejectDialogVisible(false)} className="p-button-text" />
            <Button label={t('global_btn_reject')} icon="pi pi-check" onClick={() => onUpdateApprovalListStatus(selectedExhibiton, Constants.exhibitionStatus.REJECTED)} autoFocus disabled={rejectMessage?.length === 0} />
        </div>
    );

    const renderOverview = () => {

        return (
            <div className="col-12 md:col-12">
                <div className="grid">
                    {
                        exhibitionOverviewData.map((item, index) => {
                            return (
                                <div className="col-12 md:col-2" key={index}>
                                    <div className="card widget-overview-box widget-overview-box-3 exhibit_overview-detail">
                                        <span className="">{t(item.name)}</span>
                                        <div className="flex justify-content-between">
                                            <div className="overview-detail flex justify-content-between">
                                                <div className="overview-badge flex justify-content-center align-items-center" style={{ color: "white" }}>
                                                    <i className="fa thin fa-calculator"></i>
                                                    <span>{item.count}</span>
                                                </div>
                                            </div>
                                            <div className="overview-text">%{item.percentage}</div>
                                        </div>

                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )


    }

    return (
        <div className="layout-dashboard">

            <div className="grid">
                <Toast ref={toast} />

                <div className="layout-dashboard">
                    <div className="grid">
                        {renderOverview()}

                        <div className="col-12 md:col-12">
                            <div className="card">
                                <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>

                                <DataTable value={accountList} paginator className="p-datatable-customers" showGridlines rows={10}
                                    dataKey="id" filters={filters} filterDisplay="menu" loading={displayLoadingDialog}
                                    emptyMessage={t('global_text_no_found')} rowHover selection={selectedExhibiton}
                                    onSelectionChange={e => setSelectedExhibiton(e.value)}  >

                                    <Column field="userType" header={t('global_text_usertype')} filter filterPlaceholder={t('global_text_usertype')} body={companyTypeTemplate} style={{ minWidth: '8rem' }} />

                                    <Column field="firstName" header={t('global_text_firstname')} filter filterPlaceholder={t('global_text_firstname')} style={{ minWidth: '8rem' }} />
                                    <Column field="lastName" header={t('global_text_lastname')} filter filterPlaceholder={t('global_text_lastname')} style={{ minWidth: '8rem' }} />
                                    <Column field="exhibitionName" header={t('global_exhibition_name')} filter filterPlaceholder={t('global_exhibition_name')} style={{ minWidth: '12rem' }} />


                                    <Column field="exhibitionDescr" header={t('global_exhibition_descr')} filter filterPlaceholder={t('global_exhibition_descr')} style={{ minWidth: '12rem' }} />

                                    <Column field="cdate" header={t('global_text_cdate')} filter filterPlaceholder={t('global_text_cdate')} body={dateTemplate} />
                                    <Column field="udate" header={t('global_text_udate')} filter filterPlaceholder={t('global_text_udate')} body={udateTemplate} />
                                    <Column field="uuser" header={t('global_text_uuser')} filter filterPlaceholder={t('global_text_uuser')} />

                                    <Column field="status" header={t('global_text_status')} filter body={statusBodyTemplate} />

                                    <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '10rem' }}></Column>


                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12">

                </div>

            </div>
            <Dialog visible={displayAccountDialog} onHide={() => onHideDialog()} style={{ width: '100vw', height: '100vh', maxHeight: '100vh' }} maximized={true}>
                <Exhibition profileId={selectedExhibiton?.id} viewType="view"></Exhibition>

            </Dialog>
            <Dialog header="Header" visible={rejectDialogVisible} style={{ width: '50vw' }} onHide={() => { if (!rejectDialogVisible) return; setRejectDialogVisible(false); }} footer={rejectDialogFooter}>
                <p className="m-0">
                    <InputTextarea value={rejectMessage} onChange={(e) => setRejectMessage(e.target.value)}
                        className="inputtext_raunded p-inputtext  w-12 p-4"
                        placeholder={t('exhibit_reject_message')}
                        rows={10} cols={75} autoResize maxLength={500} />
                </p>
            </Dialog>
        </div>
    )
}